import { combineReducers } from 'redux'
import solutions from './solutions'
import customers from './customers'
import devices from './devices'
import contacts from './contacts'
import teams from './teams'
import suppliers from './suppliers'
import documentation from './documentation'
import misc from './misc'
import filters from './filters'

const cmdb = combineReducers({
    solutions,
    customers,
    devices,
    contacts,
    teams,
    suppliers,
    misc,
    filters,
    documentation,
})

export default cmdb
